import { Reducer } from 'redux';

import { SuggestedCampaignsLoadAction } from '../../domains/suggestedCampaigns/actions.types';

import { SuggestedCampaigns, SuggestedCampaignsFields } from './types';

export type SuggestedCampaignsAction = SuggestedCampaignsLoadAction;

const initialSuggestedCampaigns: SuggestedCampaigns = {
  campaignIds: [],
  status: 'notRequested',
};

const setPending = (state: SuggestedCampaigns): SuggestedCampaigns => ({
  ...state,
  status: 'pending',
});

const setRejected = (state: SuggestedCampaigns): SuggestedCampaigns => ({
  ...state,
  status: 'rejected',
});

const loadSuggestedCampaignsFulfilled = (
  state: SuggestedCampaigns,
  data: SuggestedCampaignsFields
): SuggestedCampaigns => ({
  ...state,
  ...data,
  status: 'fulfilled',
});

const reducer: Reducer<SuggestedCampaigns, SuggestedCampaignsAction> = (state = initialSuggestedCampaigns, action) => {
  switch (action.type) {
    case 'SUGGESTED_CAMPAIGNS.LOAD_PENDING':
      return setPending(state);
    case 'SUGGESTED_CAMPAIGNS.LOAD_REJECTED':
      return setRejected(state);
    case 'SUGGESTED_CAMPAIGNS.LOAD_FULFILLED':
      return loadSuggestedCampaignsFulfilled(state, action.payload.entities.suggestedCampaigns);
    default:
      return state;
  }
};

export default reducer;
